import * as unspecifiedIcons from './0_unspecifiedIcons';
import * as actionIcons from './1_actionIcons';
import * as competenceIcons from './2_competenceIcons';
import * as informationIcons from './3_informationIcons';
import * as menuIcons from './4_menuIcons';
import * as notificationIcons from './5_notificationIcons';
import * as optionIcons from './6_optionIcons';
import * as ratingIcons from './7_ratingIcons';
import * as serviceIcons from './8_serviceIcons';
import * as webIcons from './9_webIcons';

export type { IconsType } from './types';

export const iconNames = {
  unspecifiedIcons: Object.keys(unspecifiedIcons) as Array<keyof typeof unspecifiedIcons>,
  actionIcons: Object.keys(actionIcons) as Array<keyof typeof actionIcons>,
  competenceIcons: Object.keys(competenceIcons) as Array<keyof typeof competenceIcons>,
  informationIcons: Object.keys(informationIcons) as Array<keyof typeof informationIcons>,
  menuIcons: Object.keys(menuIcons) as Array<keyof typeof menuIcons>,
  notificationIcons: Object.keys(notificationIcons) as Array<keyof typeof notificationIcons>,
  optionIcons: Object.keys(optionIcons) as Array<keyof typeof optionIcons>,
  ratingIcons: Object.keys(ratingIcons) as Array<keyof typeof ratingIcons>,
  serviceIcons: Object.keys(serviceIcons) as Array<keyof typeof serviceIcons>,
  webIcons: Object.keys(webIcons) as Array<keyof typeof webIcons>,
};

export default {
  ...unspecifiedIcons,
  ...actionIcons,
  ...competenceIcons,
  ...informationIcons,
  ...menuIcons,
  ...notificationIcons,
  ...optionIcons,
  ...ratingIcons,
  ...serviceIcons,
  ...webIcons,
};
